/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortDto } from './sortDto';
import { SelectedRangeDto } from './selectedRangeDto';


export interface RepairTaskFilterDto { 
    text?: string;
    page?: number;
    sort?: SortDto;
    size?: number;
    inspectionId?: string;
    tenantId?: string;
    selectedRange?: SelectedRangeDto;
    status?: RepairTaskFilterDto.StatusEnum;
    openOnly?: boolean;
    title?: string;
    contractorId?: string;
    overDue?: boolean;
    buildingId?: string;
    buildingEquipmentId?: string;
    inspectionEntryId?: string;
    statuses?: Array<RepairTaskFilterDto.StatusesEnum>;
    source?: RepairTaskFilterDto.SourceEnum;
}
export namespace RepairTaskFilterDto {
    export type StatusEnum = 'DRAFT' | 'TODO' | 'IN_PROGRESS' | 'FINISHED' | 'DECLINED';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Todo: 'TODO' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        Finished: 'FINISHED' as StatusEnum,
        Declined: 'DECLINED' as StatusEnum
    };
    export type StatusesEnum = 'DRAFT' | 'TODO' | 'IN_PROGRESS' | 'FINISHED' | 'DECLINED';
    export const StatusesEnum = {
        Draft: 'DRAFT' as StatusesEnum,
        Todo: 'TODO' as StatusesEnum,
        InProgress: 'IN_PROGRESS' as StatusesEnum,
        Finished: 'FINISHED' as StatusesEnum,
        Declined: 'DECLINED' as StatusesEnum
    };
    export type SourceEnum = 'INSPECTION_ENTRY' | 'BUILDING_EQUIPMENT';
    export const SourceEnum = {
        InspectionEntry: 'INSPECTION_ENTRY' as SourceEnum,
        BuildingEquipment: 'BUILDING_EQUIPMENT' as SourceEnum
    };
}


